// extracted by mini-css-extract-plugin
export default {"container":"app-layout_container__LooTT","content":"app-layout_content__eDX5H"};